import { OutputMigration } from '@amzn/awscat-portfolio-assessment-types';
import { FlashContextInterface, withFlashContext } from '@amzn/awscat-react-components';
import { Box, Button, Container, Grid, Header } from '@amzn/awsui-components-react';

import { constants } from '../../common/Localization';
import { formatCurrencyNoDecimals } from '../../common/LocalizationHelper';
import { generatePluralStr } from '../../common/util';
import { DEFAULT_MIGRATION_MINIMUM_LENGTH_IN_MONTHS } from './constants';

type Props = FlashContextInterface & {
    migration: OutputMigration;
    durationYears: number;
    downloadFn?: () => any;
    downloading?: boolean;
}
function MigrationSummaryBanner({ migration, durationYears, downloadFn, downloading }: Props) {
    
    const { currency, totalMigrationCost } = migration;

    const formatDuration = (durationInYears: number): string => {
        if (durationInYears < 1) {
            return `${DEFAULT_MIGRATION_MINIMUM_LENGTH_IN_MONTHS} ${constants.MONTHS}`;
        } else {
            return `${durationInYears} ${ generatePluralStr(durationInYears, constants.YEAR) }`;
        }
    };

    const header = (
        <Header variant='h1' actions={downloadFn ?
            (
                <Button iconName='download' loading={downloading} onClick={downloadFn}>{constants.DOWNLOAD}</Button>
            ) : null}>
            {constants.ESTIMATED_MIGRATION_COST}
        </Header>
    );

    const summaryDisplay = (currency: string, totalMigrationCost: number, durationYears: number): JSX.Element => {
        return (
            <Grid gridDefinition={[
                {colspan: { default: 6, xs: 6, xxs: 12}},
                {colspan: { default: 6, xs: 6, xxs: 12}},
            ]}>
                <Box textAlign='center'>
                    <div className='metric'>
                        <div>{formatCurrencyNoDecimals(totalMigrationCost, currency)}</div>
                        <span>{constants.TOTAL_ESTIMATED_MIGRATION_COST}</span>
                    </div>
                </Box>
                <Box textAlign='center'>
                    <div className='metric'>
                        <div>{ formatDuration(durationYears) }</div>
                        <span>{constants.MIGRATION_DURATION}</span>
                    </div>
                </Box>
            </Grid>
        );
    };

    return (
        <Container>
            {header}
            {summaryDisplay(currency, totalMigrationCost, durationYears)}
        </Container>
    );
}

export default withFlashContext(MigrationSummaryBanner);
